import moment from "moment";

export const convertObjectToParams = (params) => {
  if (typeof params === "string") {
    return params;
  }
  let finalParams = "";
  Object.keys(params).forEach((key, index) => {
    if (index === 0) {
      finalParams += "?";
    }
    finalParams = `${finalParams}${key}=${params[key]}`;
    if (index + 1 !== Object.keys(params).length) {
      finalParams += "&";
    }
  });

  return finalParams;
};
export const generateArrayOfYears = (yearWindow) => {
  const max = new Date().getFullYear();
  const min = max - yearWindow;
  const years = [];

  for (let i = max; i >= min; i--) {
    years.push(i);
  }
  return years;
};

export const getUserToken = () => localStorage.getItem("accessToken");

export const truncate = (str, length = 30) => (str.length > length ? `${str.substring(0, length - 3)}...` : str);

export const getAllQueriesFromURL = (url) => {
  const params = Array.from(url.keys()).reduce((acc, val) => {
    const multipleFilters = url.get(val).split(",");
    const hasMultipleFilters = multipleFilters.length > 1;

    return {
      ...acc,
      [val]: hasMultipleFilters ? multipleFilters : url.get(val)
    };
  }, {});

  return params;
};

export const isNotANumber = (val) => !/^\d*\.?\d+$/.test(val);

export const handleKeyPress = (event) => {
  if (!/^\d*\.?\d+$/.test(event.key)) {
    event.preventDefault();
  }
};

export const getFormattedOdomter = (value) => {
  const odometer =
    // eslint-disable-next-line no-nested-ternary
    value === null
      ? "Unlimited"
      : value
      ? `${new Intl.NumberFormat("en", {
          style: "decimal"
        }).format(value)} kms`
      : "-";

  return odometer;
};

export const getMomentTimeFromSeconds = (seconds) => {
  if (!seconds) return moment("10:00", "HH:mm");
  const temp = seconds / 3600;
  const hours = Math.floor(temp);
  const minutes = (temp - hours) * 60;

  return moment(`${hours}:${minutes}`, "HH:mm");
};
